// File: cgp-user-profile-dialog-component.ts
// Author: James L Seebach
// Date: 5/12/2017
// Desc: CGP User Profile component.
// Other Contributors:

import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthenticationService } from '../../auth.service';

@Component({
    selector: "cgp-app-bar-dialog",
    templateUrl: "./cgp-user-profile-dialog.template.html"
})
export class CgpUserProfileDialogComponent {
    @Input() title = 'User Profile';
    @Input() closeLabel = 'Close';
    ModuleDetail: any[] = [];
    userProfile: any;

    constructor(
        private readonly authService: AuthenticationService,
        public dialogRef: MatDialogRef<CgpUserProfileDialogComponent>,
    ) {
        authService.getUserProfile()
            .subscribe(x => {
                this.userProfile = x;
                x['ModuleClaims'].forEach(element => {
                    this.ModuleDetail.push({
                        moduleName: element,
                        roles: []
                    });
                });
                x['RoleClaims'].forEach(element => {
                    const split = element.split(':', 2);
                    this.ModuleDetail.forEach(element => {
                        if (element.moduleName === split[0]) {
                            element.roles.push(split[1])
                            element.roles.sort();
                        }
                    });
                });
            });
    }
}

